import { apiWithBody, apiWithQuery, ModuleFE_BaseApi, ModuleFE_XHR } from '@nu-art/thunderstorm-frontend/index';
import { HeaderKey_ContentType } from '@nu-art/thunderstorm-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_Pathway, ApiDef_PathwayHtml, DBDef_Pathway, PathwayCollectionPermissionKeys, PathwayEditorPermissionKeys } from '@app/pathway-shared';
import { ModuleFE_Discussion, ModuleFE_Expression } from '@app/hcs-frontend';
import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
import { MimeType_html } from '@nu-art/ts-common';
import { ModuleFE_PathwayState } from '../pathway-state/index.js';
import { ModuleFE_PathwayTransition } from '../pathway-transition/index.js';
export const dispatch_onPathwayChanged = new ThunderDispatcherV3('__onPathwayUpdated');
export class ModuleFE_Pathway_Class extends ModuleFE_BaseApi {
    _v1;
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: items.map(i => ({ _id: i._id, uiLabel: i.label }))
        }]);
    __searchFilterMapper = (item) => [item.label];
    permissions;
    constructor() {
        super(DBDef_Pathway, dispatch_onPathwayChanged);
        this._v1 = {
            duplicatePathway: apiWithBody(ApiDef_Pathway._v1.duplicatePathway, async (res) => {
                await Promise.all([
                    this.onEntriesUpdated([res.newPathway]),
                    ModuleFE_PathwayState.onEntriesUpdated(res.newStates),
                    ModuleFE_PathwayTransition.onEntriesUpdated(res.newTransitions),
                    ModuleFE_Expression.onEntriesUpdated(res.newResolutionFunctions),
                ]);
            }),
            createChildPathway: apiWithBody(ApiDef_Pathway._v1.createChildPathway, async (res) => {
                await Promise.all([
                    this.onEntriesUpdated([res.pathway]),
                    ModuleFE_PathwayState.onEntriesUpdated(res.pathwayStates),
                    ModuleFE_PathwayTransition.onEntriesUpdated(res.pathwayTransitions)
                ]);
            }),
            deletePathway: apiWithQuery(ApiDef_Pathway._v1.deletePathway, this.onPathwayDeleted),
            createPathway: apiWithBody(ApiDef_Pathway._v1.createPathway, this.onPathwayCreated),
            detachPathwayFromParent: apiWithBody(ApiDef_Pathway._v1.detachPathwayFromParent, async (res) => {
                await Promise.all([
                    this.onEntriesUpdated([res.pathway]),
                    ModuleFE_PathwayState.onEntriesUpdated(res.pathwayStates),
                    ModuleFE_PathwayTransition.onEntriesUpdated(res.pathwayTransitions),
                    ModuleFE_Expression.onEntriesUpdated(res.resolutionFunctions),
                ]);
            }),
            togglePathwayArchiveStatus: apiWithBody(ApiDef_Pathway._v1.togglePathwayArchiveStatus, async (response) => {
                this.onEntriesUpdated([response.pathway]);
            }),
            togglePathwayUnderConstruction: apiWithBody(ApiDef_Pathway._v1.togglePathwayUnderConstruction, async (response) => {
                this.onEntriesUpdated([response.pathway]);
            })
        };
        // permission declerations
        this.permissions = {
            ui: PermissionKey_FE.generatePermissionKeysByLevels(PathwayEditorPermissionKeys),
            collection: PermissionKey_FE.generatePermissionKeysByLevels(PathwayCollectionPermissionKeys),
        };
    }
    init() {
        super.init();
        ModuleFE_Discussion.registerLabelFromEntityConverter(this.dbDef.dbKey, (pathway) => pathway.label);
    }
    onPathwayDeleted = async (response) => {
        await Promise.all([
            this.onEntriesDeleted(response.pathways.deleted),
            this.onEntriesUpdated(response.pathways.updated),
            ModuleFE_PathwayState.onEntriesDeleted(response.states.deleted),
            ModuleFE_PathwayState.onEntriesUpdated(response.states.updated),
            ModuleFE_PathwayTransition.onEntriesDeleted(response.transitions.deleted),
            ModuleFE_PathwayTransition.onEntriesUpdated(response.transitions.updated),
            ModuleFE_Expression.onEntriesDeleted(response.resolutionFunctions)
        ]);
    };
    onPathwayCreated = async (response) => {
        await this.onEntriesUpdated([response.pathway]);
        await ModuleFE_PathwayState.onEntriesUpdated(response.states);
    };
    getChildren = (pathwayId) => {
        return this.cache.filter(pathway => pathway._parentId === pathwayId);
    };
    isParent = (pathwayId) => {
        return !!this.getChildren(pathwayId).length;
    };
    getNonArchivedPathways = () => {
        return this.cache.filter(pathway => !pathway.archived);
    };
    // ---- HTML attach/replace/remove for a saved pathway (edit mode) ----
    // Attach or replace the pathway HTML. The file travels as the raw text/html body (like the CSV
    // import), so this uses ModuleFE_XHR rather than apiWithBody. Reseeds the cache with the updated
    // pathway so the Review link + HTML overlay re-derive from the new pathwayHtmlUrl.
    setPathwayHtml = async (pathwayId, file) => {
        const { pathway } = await ModuleFE_XHR.createRequest(ApiDef_PathwayHtml._v1.setPathwayHtml)
            .setUrlParams({ pathwayId })
            .setTimeout(ApiDef_PathwayHtml._v1.setPathwayHtml.timeout)
            .setHeader(HeaderKey_ContentType, MimeType_html)
            .setBody(file, false)
            .executeSync();
        await this.onEntriesUpdated([pathway]);
    };
    removePathwayHtml = async (pathwayId) => {
        const { pathway } = await ModuleFE_XHR.createRequest(ApiDef_PathwayHtml._v1.removePathwayHtml)
            .setTimeout(ApiDef_PathwayHtml._v1.removePathwayHtml.timeout)
            .setBodyAsJson({ pathwayId })
            .executeSync();
        await this.onEntriesUpdated([pathway]);
    };
}
export const ModuleFE_Pathway = new ModuleFE_Pathway_Class();
//# sourceMappingURL=ModuleFE_Pathway.js.map